
/**
 * Global Key Constants
 * 
 * Centralized configuration for all key constants used across the application.
 * These constants represent keys, identifiers, and classification values.
 */

// ============================================
// Classification Keys
// ============================================

export const CLASSIFICATION_KEYS = {
    BUSINESS_QUERY: "business_query",
    OVERALL: "overall",
};

// ============================================
// Agent Types
// ============================================

export const AGENT_TYPES = {
    CHAT_GENIE: "CHAT_GENIE",
    GMT: "GMT",
    PROCUREMENT_AI: "PROCUREMENT_AI",
    DEEP_INSIGHTS: "DEEP_INSIGHTS",
    TALENT_PULSE_360: "TALENT_PULSE_360",
};



// ============================================
// Storage Keys (localStorage/sessionStorage)
// ============================================

export const STORAGE_KEYS = {
    INTENDED_ROUTE: "intendedRoute",
    LOGGED_IN_DETAILS: "LoggedInDetails",
    IS_POLICY: "isPolicy",
    IS_LOGIN: "isLogin",
    SHOW_TOUR_GUIDE: "showTourGuide",
    LOGOUT: "logout",
    TOKEN: "token",
    USER_ROLE: "userRole",
    SHOW_NEW_MODEL_INFO: "showNewModelInfo",
    IS_PERSONAL_POLICY: "isPersonalPolicy",
    LAST_NPS_CHECK_DATE: "lastNPSCheckDate",
};

// ============================================
// Query Parameters
// ============================================

export const QUERY_PARAMS = {
    CODE: "code",
};

// ============================================
// Routes
// ============================================

export const ROUTES = {
    CHAT: "/chat",
    SIGN_IN: "/sign-in",
    MY_APPS: "/my-apps",
    USER_MANAGEMENT: "/user-management",
    VIDEO_TUTORIALS: "/video-tutorials",
    PROCUREMENT_AI: "/proc-ai",
    GMT_CHAT: "/gmt-chat",
    DEEP_INSIGHTS_CHAT: "/deep-insights-chat",
    TALENT_PULSE_360: "/talent-pulse-360",
    TALENT_PULSE_360_ADMIN: "/talent-pulse-360-admin",
    TALENT_PULSE_360_SURVEY: "/talent-pulse-360-survey",
    TRANSLATE: "/translate",
};

// ============================================
// Feedback Constants
// ============================================

export const FEEDBACK_KEYS = {
    LIKE: "like",
    DISLIKE: "dislike",
};

// ============================================
// Configuration Constants
// ============================================

export const CONFIG = {
    MOBILE_BREAKPOINT: 768,
    SSO_TIMEOUT: 5000, // milliseconds
    TOAST_AUTO_CLOSE: 1000, // milliseconds
    TOAST_POSITION: "top-right",
};

// ============================================
// Role Constants
// ============================================

export const ROLE_ACCESS = {
    ADMIN: "ADMIN",
    USER: "USER",
    SUPERADMIN: "SUPERADMIN",
};

// ============================================
// Session Types
// ============================================

export const SESSION_TYPES = {
    IMAGE_GENERATION: "IMAGE_GENERATION",
    PRODUCT_LABELS: "PRODUCT_LABELS",
    EXCEL_ANALYSIS: "EXCEL_ANALYSIS"
};

export const ROLE_TYPES = {
    PRODUCT_LABEL: "product-label",
    EXCEL_ANALYSIS: "excel-analysis"
}

// ============================================
// Consent Status
// ============================================

export const CONSENT_STATUS = {
    ACCEPTED: "accepted",
    DISMISSED: "dismissed",
};

// ============================================
// Prompt Constants
// ============================================

export const PROMPT_TYPE = {
    PERSONAL: "personal",
    SUGGESTED: "suggested",
};

// ============================================
// Master Table Keys
// ============================================

export const MASTER_TABLE_KEYS = {
    DEFAULT_PAGE_SIZE: 10,
    DEFAULT_ROW_KEY: "id",
};

// ============================================
// SSE Event Constants
// ============================================

export const SSE_EVENTS = {
    START: "start",
    REGENERATE_START: "regenerate_start",
    PROGRESS: "progress",
    STEP: "step",
    TOOL_START: "tool_start",
    TOOL_END: "tool_end",
    TOKEN: "token",
    CITATIONS: "citations",
    SOURCES: "sources",
    FOLLOW_UP: "follow_up",
    THREAD_TITLE: "thread_title",
    FINAL: "final",
    DONE: "done",
    STREAM_COMPLETE: "stream_complete",
    ERROR: "error",
    WEB_SEARCH_SUGGESTION: "web_search_suggestion",
    WEB_SEARCH_CONSENT_REQUIRED: "web_search_consent_required",
    ROUTER_DISABLED: "router_disabled",
    CHART: "chart",
};

// ============================================
// Unified Keys Object
// ============================================

export const KEYS = {
    CLASSIFICATION: CLASSIFICATION_KEYS,
    STORAGE: STORAGE_KEYS,
    QUERY: QUERY_PARAMS,
    ROUTES: ROUTES,
    FEEDBACK: FEEDBACK_KEYS,
    ROLE: ROLE_ACCESS,
    SESSION: SESSION_TYPES,
    ROLE_TYPES: ROLE_TYPES,
    CONSENT: CONSENT_STATUS,
    PROMPT: PROMPT_TYPE,
    MASTER_TABLE: MASTER_TABLE_KEYS,
    AGENT: AGENT_TYPES,
    SSE: SSE_EVENTS,
};
